import { render, staticRenderFns } from "./VerMais.vue?vue&type=template&id=8140247e&scoped=true"
import script from "./VerMais.vue?vue&type=script&lang=js"
export * from "./VerMais.vue?vue&type=script&lang=js"
import style0 from "./VerMais.vue?vue&type=style&index=0&id=8140247e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8140247e",
  null
  
)

export default component.exports